import { Modal } from "./Modal";

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  title, message, confirmLabel = "Confirmar", cancelLabel = "Cancelar",
  danger = false, onConfirm, onCancel,
}: ConfirmModalProps) {
  return (
    <Modal onClose={onCancel}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 30, marginBottom: 10 }}>{danger ? "👋" : "✨"}</div>
        <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 21, margin: "0 0 8px" }}>
          {title}
        </h2>
        <p style={{ fontSize: 14.5, color: "var(--muted)", lineHeight: 1.55, margin: "0 0 24px" }}>
          {message}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onCancel} className="btn btn-outline" style={{ flex: 1 }}>
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="btn"
            style={{
              flex: 1,
              background: danger ? "#BC5950" : "var(--copper)",
              color: "#fff",
              boxShadow: "var(--shadow-btn)",
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
